import { DEFAULT_SCHEDULE_ORDER_BY, SCHEDULE_SESSION_DISPLAY_TYPE_ROUND } from 'common-data-handling';
import _, { identity } from 'lodash';
import { useMemo } from 'react';
import { isSessionAttendanceOptional, isSessionAttendanceRequired, isSessionOverlaping } from '../../filters/scheduleFilters';
import { useEventSchedule } from './useEventSchedule';

/**
 * Returns all the sessions selected or when there's no user selection, the corresponding round
 * @param {array}       eventSchedule           Event schedule sessions
 * @param {function}    filter                  Filter to be applied to every item
 * @param {string}      orderBy                 Sort configuration (default DEFAULT_SCHEDULE_ORDER_BY)
 * @param {boolean}     noSelectableOverlaping  Don't show unselected rounds that are overlaped by other selected items
 * @returns {array}
 */
export function selectUserPotentialSchedule(eventSchedule, filter = identity, orderBy = DEFAULT_SCHEDULE_ORDER_BY, noSelectableOverlaping = false) {
    let schedule = _(eventSchedule)
        .filter((session) => (session.is_selected || !session.is_selectable || !session.round_id) && !session.display_category)
        .filter((session) => session.display_type != SCHEDULE_SESSION_DISPLAY_TYPE_ROUND || !eventSchedule.find((s) => s.round_id == session.id && s.is_selected))
        .value();

    if (noSelectableOverlaping) {
        schedule = schedule.filter(
            (s1) =>
                // normal sessions where user is expected to be
                isSessionAttendanceRequired(s1) ||
                // + rounds or selectable sessions that aren't conflicting
                (isSessionAttendanceOptional(s1) && !schedule.find((s2) => s1 != s2 && isSessionAttendanceRequired(s2) && isSessionOverlaping(s1, s2)))
        );
    }

    return _(schedule).filter(filter).sortBy(orderBy).value();
}

export function useUserPotentialSchedule(eventId, { filter, orderBy, noSelectableOverlaping } = {}) {
    const schedule = useEventSchedule(eventId);
    return useMemo(
        () => selectUserPotentialSchedule(schedule, filter, orderBy, noSelectableOverlaping),
        [schedule, filter, orderBy, noSelectableOverlaping]
    );
}
